/* eslint-disable react-hooks/exhaustive-deps */
import { FunctionComponent as F, useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerNewUserAsync } from "../../core/store/user/user.thunks";
import { useAppDispatch } from "../../core/store/hooks";
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { PROTOCOL } from "../../core/router/paths";
import PageHeadline from "../../components/UI/Text/PageHeadline";
import { validateEmail, validateUsername, validatePassword } from "../../utils/validate";
import CountrySelect from "../../components/Account/CountrySelect";

const CreateAccount: F = () =>
{
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();

  const [message, setMessage] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [usernameError, setUsernameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [password2Error, setPassword2Error] = useState(false);


  const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) =>
  {
    setUsername(event.target.value);
    setUsernameError(!validateUsername(event.target.value));
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) =>
  {
    const value = event.target.value;
    setEmail(value);
    setEmailError(Boolean(value) && !validateEmail(value));
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) =>
  {
    setPassword(event.target.value);
    setPasswordError(!validatePassword(event.target.value));
    setPassword2Error(event.target.value !== password2);
  };

  const handlePassword2Change = (event: React.ChangeEvent<HTMLInputElement>) =>
  {
    setPassword2(event.target.value);
    setPassword2Error(event.target.value !== password);
  };

  async function handleSubmit(username: string, password: string, email: string)
  {
    if(!username || !password || usernameError || passwordError || password2Error || emailError)
      return;

    appDispatch(registerNewUserAsync(username, password, email))
      .then(res =>
      {
        if(res.success)
          navigate(PROTOCOL);
        else if(res.usernameExists)
          setMessage("Account with this username already exists");
        else if(res.emailExists)
          setMessage("Account with this email already exists");
        else
          setMessage("Error logging in");
      });
  }

  return (
    <Container>
      <Stack sx={{ pt: 10 }} spacing={2}>
        <PageHeadline>Create Account</PageHeadline>
        <TextField
          id='Username'
          size='small'
          label='Username*'
          value={username}
          onChange={handleUsernameChange}
          error={usernameError} />
        <TextField
          id='Email'
          size='small'
          label='Email*'
          value={email}
          onChange={handleEmailChange}
          error={emailError} />
        <TextField
          id='Password'
          size='small'
          type='password'
          label='Password*'
          value={password}
          onChange={handlePasswordChange}
          error={passwordError} />
        <TextField
          id='ConfirmPassword'
          size='small'
          type='password'
          label='Confirm password*'
          value={password2}
          onChange={handlePassword2Change}
          error={password2Error} />
        <Stack direction='row' spacing={1}>
          <Typography variant='body1' gutterBottom>Location:</Typography>
          <Box>
            <CountrySelect/>
          </Box>
        </Stack>
        <Button
          id='Submit'
          variant='contained'
          sx={{ width: '100px' }}
          onClick={() => handleSubmit(username, password, email)}>
          Submit
        </Button>
        <Typography
          sx={{ fontStyle: 'italic' }}
          variant='subtitle1'
          gutterBottom>
          {message}
        </Typography>
      </Stack>
    </Container>);
};

export default CreateAccount;
